export const headers = [
    {
        "ordre": 1,
        "champ": "div_nom",
        "label_champ": "Division",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "120",
        "add_only": false,
        "modif": false,
        "tooltip": " "
    },
    {
        "ordre": 2,
        "champ": "plans_nom",
        "label_champ": "Section",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 3,
        "champ": "mag_nom",
        "label_champ": "Magasin",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 4,
        "champ": "four_nom",
        "label_champ": "Fournisseur",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "250",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 5,
        "champ": "mod_descr",
        "label_champ": "Description",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "250",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 6,
        "champ": "prod_num",
        "label_champ": "Produit",
        "format_champ": "{0:0000000}",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 7,
        "champ": "act_cd",
        "label_champ": "Code Act",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "120",
        "add_only": false,
        "modif": true,
        "tooltip": ""

    },
    {
        "ordre": 8,
        "champ": "mod_cd",
        "label_champ": "Model",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "200",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 9,
        "champ": "prod_collection",
        "label_champ": "Collection",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": true,
        "tooltip": ""

    },
    {
        "ordre": 10,
        "champ": "statut_aff",
        "label_champ": "Statut",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "100",
        "add_only": false,
        "modif": false,
        "tooltip": "Actif: Produit présent sur le plancher VersPL: Produit absent du plancher dont la date de début ou d'entrée est dans le futur. SortirPL: Produit présent sur le plancher dont la date de fin ou de sortie est dans le passé. Vendu: Produit présent sur le plancher dont la date de fin ou de sortie est dans le passé, pour lequel une réservation est trouvée.  La date requise de la ligne de contrat est affiché comme date de fin à titre indicatif. Inactif: Produit absent du plancher avec une date de fin dans le passé"

    },
    {
        "ordre": 11,
        "champ": "sur_plancher",
        "label_champ": "En Magasin",
        "condition_champ": "un_magasin",
        "label_champ_alt": "Sur Plancher",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 12,
        "champ": "style_aff",
        "label_champ": "Style",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 13,
        "champ": "nbr_mcx",
        "label_champ": "Nb Mcx",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "100",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 14,
        "champ": "prix_vente",
        "label_champ": "Prix",
        "format_champ": "{0:c}",
        "affiche_tableau": true,
        "width": "120",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 15,
        "champ": "planost_ventes",
        "label_champ": "Ventes $",
        "format_champ": "{0:c}",
        "affiche_tableau": true,
        "width": "120",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 16,
        "champ": "planost_ventes_mcx",
        "label_champ": "Qté",
        "format_champ": "{0:n}",
        "affiche_tableau": true,
        "width": "80",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 17,
        "champ": "pcarre",
        "label_champ": "P2",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "80",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 18,
        "champ": "ventes_jr_p2",
        "label_champ": "$ P2 / Jr",
        "format_champ": "{0:c}",
        "affiche_tableau": true,
        "width": "100",
        "add_only": false,
        "modif": false,
        "tooltip": "Moyenne des ventes par jour par pied² depuis la date de début. Si pi² = 0 alors moyenne des ventes par jour depuis la date de début"

    },
    {
        "ordre": 19,
        "champ": "plano_dt_deb",
        "label_champ": "Date Début",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "120",
        "add_only": false,
        "modif": false,
        "tooltip": "Date où le produit est apparu sur le plancher"

    },
    {
        "ordre": 20,
        "champ": "nbr_jr_demo",
        "label_champ": "Jr Démo",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "100",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    },
    {
        "ordre": 21,
        "champ": "histo",
        "label_champ": "Historique",
        "format_champ": "",
        "affiche_tableau": true,
        "width": "150",
        "add_only": false,
        "modif": false,
        "tooltip": ""

    }
]